import { Injectable } from '@angular/core';
import { User } from '../models/auth.models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    constructor(private http: HttpClient) {
    }

    /**
     * Returns the current user
     */
    public currentUser(): any {
       // return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(credentials: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/auth/login`, credentials, { withCredentials: true });
    }

    verify2FA(data: { user_id: number, totp_code: string }): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/auth/verify-2fa`, data, { withCredentials: true })
          .pipe(
            tap(res => {
              if (res.status === 200) {
                this.setToken(res.token);
                this.setUser(JSON.stringify(res.user));
              }
            })
          );
    }

    setToken(token: string): void {
        localStorage.setItem('token', token);
    }

    setUser(user: string): void {
        localStorage.setItem('user', user);
    }

    getUser(): any | null {
        const user = localStorage.getItem('user');
        if (!user) return null;
        const parsed = JSON.parse(user);
        const token = this.getToken();
        if (parsed && token) {
            const decoded = this.parseJwt(token);
            parsed.is_admin = decoded?.is_admin; // always trust JWT over localStorage
        }
        return parsed;
    }

    getToken(): string | null {
        return localStorage.getItem('token');
    }

    checkUserAccess(): boolean {
        const token = this.getToken();
        if (!token) return false;
        const decodedToken = this.parseJwt(token);
        return !!decodedToken?.is_admin;
    }

    private parseJwt(token: string): any {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(user: User): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/auth/register`, user);
    }

    isLoggedIn(): boolean {
        const token = this.getToken();
        if (!token) return false;
        const decoded = this.parseJwt(token);
        return decoded?.exp > Math.floor(Date.now() / 1000);
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(id: number, newPassword: string): Observable<any> {
        const token = this.getToken();
        return this.http.put<any>(
            `${environment.apiUrl}/auth/resetPassword/${id}`,
            { new_password: newPassword },
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }

    /**
     * Logout the user
     */
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
}

